import './_styles.scss';
import React from 'react';
import { FiLoader } from 'react-icons/fi';
import { Input, Checkbox } from 'components';

export default ({ visible, state, onChangeEvent, onValidate, toggleView }) => {

  return (!!visible) && (
    <form className='Login-Form' onSubmit={(e) => e.preventDefault()}>

      <div className="Title">Sign in</div>

      <div className="Placeholder">Enter Email Address</div>

      <Input
        type='email'
        name='email_address'
        value={state.email_address}
        onChange={onChangeEvent}
        error={state.errors['email_address']}
        readOnly={state.loading}
      />

      <div className="Caption">
        <div className="Placeholder">Enter Your Password</div>
        <div className="link">Forgot Password?</div>
      </div>

      <Input
        type='password'
        name='password'
        value={state.password}
        onChange={onChangeEvent}
        error={state.errors['password']}
        readOnly={state.loading}
      />

      <button className='Login-Button' onClick={onValidate} disabled={state.loading}>
        {(state.loading) && <FiLoader className='loader'/>}
        <span className='button-text'>Sign In</span>
      </button>

      <div className="Legal">
        <span>By continuing, you agree to Adenzo's</span>
        <span className='link'> Conditions of Use</span> and <span className='link'>Privacy Notice</span>.
      </div>

      <Checkbox
        name='remember'
        value={state.remember}
        caption='Keep me signed in.'
        onSelect={onChangeEvent}
      />

      <div className="Divider">
        <span>New to Adenzo?</span>
      </div>

      <button className='Signup-Button' onClick={() => toggleView()}>
        Create Account
      </button>

    </form>
  )
}
